import { Typography } from "@mui/material";
import React from "react";
import { v4 as uuidv4 } from "uuid";

export const isNullOrBlank = (value: string | null | undefined): boolean => {
	return value === null || value === undefined || value.trim() === "";
};

export const capitalize = (value: string): string => {
	return value.charAt(0).toUpperCase() + value.slice(1);
};

type FormatOperation = "capitalize" | "add_dot";

export const formatStr = (value: string, ...operations: FormatOperation[]): string => {
	let formatted = value;
	if (operations.includes("capitalize")) {
		formatted = capitalize(formatted);
	}
	if (operations.includes("add_dot")) {
		formatted = formatted + ".";
	}
	return formatted;
};

export const booleanToString = (value: boolean): "yes" | "no" => {
	if (value) {
		return "yes";
	}
	return "no";
};

export const stringToHtml = (value: string): React.ReactNode[] => {
	const elements: React.ReactNode[] = [];
	const parts = value.split("\n");
	const last = parts.slice(-1);
	const other = parts.slice(0, -1);
	other.forEach((row) => {
		elements.push(<Typography key={uuidv4()}>{row}</Typography>);
		elements.push(<br key={uuidv4()} />);
	});
	last.forEach((lastRow) => {
		elements.push(<Typography key={uuidv4()}>{lastRow}</Typography>);
	});
	return elements;
};

export const camelToSnakeCase = (value: string) =>
	value.replace(/[A-Z]/g, (letter, index) => {
		return index === 0 ? letter.toLowerCase() : "_" + letter.toLowerCase();
	});

export const removeFileExtension = (fileName: string) => fileName.replace(/\.[^/.]+$/, "");

export const containsIgnoreCase = (value: string | undefined | null, search: string) => {
	if (value == undefined) return false;

	return value.toLowerCase().includes(search.toLowerCase());
};
